export { default } from './Columns';
export type { Props, Props as IconListColumnsProps } from './Columns';
